// Working Smooth Scroll with Modal Detection
(function() {
  'use strict';

  let isScrolling = false;
  let scrollTarget = 0;
  let currentScroll = 0;
  let velocity = 0;
  let ease = 0.08;
  let friction = 0.92;
  let wheelMultiplier = 0.5;/* マウスホイール距離 */
  let isModalOpen = false;

  function lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  function updateScroll() {
    velocity *= friction;
    scrollTarget += velocity;
    
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));
    
    if (Math.abs(scrollTarget - currentScroll) < 0.1 && Math.abs(velocity) < 0.1) {
      currentScroll = scrollTarget;
      window.scrollTo(0, currentScroll);
      velocity = 0;
      isScrolling = false;
      return;
    }
    
    currentScroll = lerp(currentScroll, scrollTarget, ease);
    window.scrollTo(0, currentScroll);
    
    if (isScrolling) {
      requestAnimationFrame(updateScroll);
    }
  }

  function checkModalState() {
    const prevState = isModalOpen;
    
    const modalClasses = ['modal-open', 'overlay-open', 'no-scroll', 'scroll-locked'];
    const hasModalClass = modalClasses.some(cls => 
      document.body.classList.contains(cls) || 
      document.documentElement.classList.contains(cls)
    );

    const modals = document.querySelectorAll('.modal, .overlay, .lightbox, .popup, [data-modal], [aria-modal="true"], .product-media-modal, .media-modal, media-gallery');
    let hasVisibleModal = false;
    
    for (let modal of modals) {
      const style = window.getComputedStyle(modal);
      if (style.display !== 'none' && 
          style.visibility !== 'hidden' && 
          style.opacity !== '0' &&
          modal.offsetParent !== null) {
        hasVisibleModal = true;
        break;
      }
    }

    isModalOpen = hasModalClass || hasVisibleModal;

    if (prevState !== isModalOpen) {
      if (isModalOpen) {
        console.log('Modal detected - smooth scroll disabled');
      } else {
        console.log('Modal closed - smooth scroll enabled');
      }
    }

    return isModalOpen;
  }

  function handleWheel(e) {
    if (checkModalState()) {
      return;
    }

    e.preventDefault();
    
    let delta = 0;
    if (e.wheelDelta) {
      delta = -e.wheelDelta / 120;
    } else if (e.detail) {
      delta = e.detail / 3;
    } else if (e.deltaY) {
      delta = e.deltaY / 120;
    }
    
    const scrollAmount = delta * 60 * wheelMultiplier;
    velocity += scrollAmount * 0.15;
    scrollTarget += scrollAmount;
    
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));
    
    if (!isScrolling) {
      isScrolling = true;
      requestAnimationFrame(updateScroll);
    }
  }

  function init() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      console.log('Smooth scroll disabled: mobile device');
      return;
    }
    
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      console.log('Smooth scroll disabled: prefers-reduced-motion');
      return;
    }

    scrollTarget = currentScroll = window.pageYOffset;
    
    document.documentElement.classList.add('smooth-scroll-enabled');
    document.documentElement.style.scrollBehavior = 'auto';
    
    document.addEventListener('wheel', handleWheel, { passive: false });
    document.addEventListener('DOMMouseScroll', handleWheel, { passive: false });
    
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (!isScrolling) {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          scrollTarget = currentScroll = window.pageYOffset;
        }, 100);
      }
    });
    
    window.addEventListener('resize', function() {
      scrollTarget = currentScroll = window.pageYOffset;
    });
    
    document.addEventListener('click', function(e) {
      if (checkModalState()) return;
      
      const link = e.target.closest('a[href^="#"]');
      if (link) {
        const href = link.getAttribute('href');
        if (href !== '#') {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            const targetY = target.offsetTop - 100;
            
            const startY = currentScroll;
            const distance = targetY - startY;
            const duration = 1200;
            let startTime = null;
            
            function animateToTarget(timestamp) {
              if (!startTime) startTime = timestamp;
              const elapsed = timestamp - startTime;
              const progress = Math.min(elapsed / duration, 1);
              
              const easeProgress = progress < 0.5 
                ? 4 * progress * progress * progress 
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;
              
              scrollTarget = startY + distance * easeProgress;
              
              if (progress < 1) {
                requestAnimationFrame(animateToTarget);
              }
            }
            
            requestAnimationFrame(animateToTarget);
          }
        }
      }
    });

    console.log('Smooth scroll initialized with modal detection');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.smoothScrollControl = {
    setEase: function(value) {
      ease = Math.max(0.01, Math.min(0.3, value));
      console.log('Ease set to:', ease);
    },
    setMultiplier: function(value) {
      wheelMultiplier = Math.max(0.1, Math.min(5, value));
      console.log('Multiplier set to:', wheelMultiplier);
    },
    disable: function() {
      isModalOpen = true;
      console.log('Smooth scroll manually disabled');
    },
    enable: function() {
      isModalOpen = false;
      console.log('Smooth scroll manually enabled');
    },
    isEnabled: function() {
      return !isModalOpen;
    },
    checkModal: function() {
      return checkModalState();
    }
  };

})();
